import { Box, Tooltip, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setAcademicYear } from '../../features/academicYear/academicYearSlice';
import { useAuth } from '../../hooks/useAuth';
import { GetAllAcademicYearList } from '../../api/SchoolService/SchoolService';
import { useSnackbar } from '../MUIComponent/FeedbackComponent/SnackBar/SnackbarContext';
import { getSchoolProfileSuccess } from '../../features/schoolProfile/schoolProfileSlice';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';
import { useTranslation } from 'react-i18next';

const HeaderYearDropdown = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { showSnackbar } = useSnackbar();
  const { user } = useAuth();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { schoolProfileData } = useSelector(state => state.schoolProfile);
  const [loading, setLoading] = useState(false);
  const customColors = useSelector((state) => state.theme.customColors);
  const academicYear = useSelector((state) => state.academicYear.academicYear);
  const academicYearList = useSelector((state) => state.academicYearList.academicYearList);
  const ActiveAcademicYears = useSelector((state) => state.academicYear.academicYear);
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  const labelYear = "Academic Year:";

  const toStorageFormat = (display) => {
    return display.academicYear;
  };

  const [selectedOption, setSelectedOption] = useState(ActiveAcademicYears || null);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleSelect = (option) => {
    const schoolProfileUpdate = { ...schoolProfileData, academicYearEnd: option.startDate, academicYearStart: option.endDate };
    dispatch(getSchoolProfileSuccess(schoolProfileUpdate));
    setSelectedOption(option.academicYear);
    dispatch(setAcademicYear(option));
    setIsOpen(false);
    navigate(ROUTES.HOME);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  useEffect(() => {
    if (ActiveAcademicYears?.academicYearID && Array.isArray(academicYearList)) {
      const active = academicYearList.find(
        item => item.academicYearID === ActiveAcademicYears.academicYearID
      );

      if (active) {
        setSelectedOption(active);
        dispatch(setAcademicYear(active));
        return;
      } else{
         const toLocalDateString = (date) => {
          const d = new Date(date);
          const year = d.getFullYear();
          const month = String(d.getMonth() + 1).padStart(2, "0");
          const day = String(d.getDate()).padStart(2, "0");
          return `${year}-${month}-${day}`;
        };
          const todayStr = toLocalDateString(new Date());

          let current = academicYearList.find(session => {
            const startStr = toLocalDateString(session.startDate);
            const endStr = toLocalDateString(session.endDate);

            return todayStr >= startStr && todayStr <= endStr;
          });

          if (!current && academicYearList.length > 0) {
            current = [...academicYearList].sort(
              (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
            )[0];
          }

        setSelectedOption(current);
        dispatch(setAcademicYear(current));
      }
    }
}, [user?.schoolID, ActiveAcademicYears, academicYearList]);

  return (
    <Box className="year-dropdown" ref={dropdownRef}>
      <Tooltip 
      // title="Prev Year Filter"
      >
        <Box
          className="year-dropdown-header"
          onClick={toggleDropdown}
          sx={{
            borderColor: theme.palette.custom.borderColor,
            background: customColors?.activeButton || theme.palette.background.bgpurple,
            color: customColors?.activeTextColor || theme.palette.custom.whitetext,
            // minWidth: isMobile ? 'auto' : '240px',
            cursor:'pointer'
          }}
        >
       
          <i class="fa-sharp fa-regular fa-calendar-days"></i>
          {!isMobile && <span>{academicYear?.academicYear || t('header.pleaseSelectYear')}</span>}
        </Box>
      </Tooltip>
      {isOpen && (
        <Box
          component="ul"
          className="year-dropdown-list"
          sx={{
            backgroundColor: theme.palette.background.bgwhite,
            minWidth: '240px',
          }}
        >
          {academicYearList?.length > 0 && academicYearList.map((option, index) => {
            const isSelected = selectedOption?.academicYear === toStorageFormat(option);
            const today = new Date();

            const isCurrent =
              new Date(option.startDate) <= today &&
              new Date(option.endDate) >= today;
              
            
          return (
              <Box
              component="li"
              key={index}
              onClick={() => handleSelect(option)}
              // sx={{
              //   color: theme.palette.background.text,
              //   padding: '8px 16px',
              //   cursor: 'pointer',
              //   backgroundColor: theme.palette.background.bgwhite,
              //   '&:hover': {
              //     backgroundColor: theme.palette.custom.listMenuhoverbg,
              //   },
              // }}
              sx={{
                padding: '8px 16px',
                cursor: 'pointer',
               backgroundColor: isSelected
                  ? theme.palette.custom.listMenuhoverbg
                  : isCurrent
                    ? theme.palette.action.hover
                    : theme.palette.background.bgwhite,

                color: isSelected
                  ? theme.palette.background.bgpurple
                  : isCurrent
                    ? theme.palette.primary.main
                    : theme.palette.background.text,
                fontWeight:
                  selectedOption?.academicYear === toStorageFormat(option) ? 600 : 400,
                '&:hover': {
                  backgroundColor: theme.palette.custom.listMenuhoverbg,
                },
              }}
            >
              {labelYear} {option.academicYear} 
              {isCurrent && (
                  <i
                    className="fa-solid fa-circle"
                    style={{
                      fontSize: "8px",
                      marginLeft: "6px",
                      color: customColors,
                    }}
                  />
                )}
            </Box>
          )})}
        </Box>
      )}
    </Box>
  );
};

export default HeaderYearDropdown;